var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTralli = function SvgTralli(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tralli_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tralli_svg__c",
    width: 140,
    height: 25,
    x: 0,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.188 18.256h14.316v2.066h-6.138v10.284a2.05 2.05 0 0 1-2.042 2.055V20.32h-6.137v-2.065z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tralli_svg__b)",
    d: "M11.097 16.915.8 20.31l8.291.003v12.31L15.26 20.31h10.418l6.399-6.33a48 48 0 0 0-1.293-.018c-6.83 0-13.961 1.416-19.686 2.952"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m38.117 8.002-5.15 5.095c-4.377-.202-8.946.239-13.256.976z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tralli_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M.8 4.402H38v27.6H.8z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tralli_svg__b",
    x1: 32.532,
    x2: 4.873,
    y1: 10.703,
    y2: 26.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4AC79",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4AC79"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tralli_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.8.8h38.4v38.4H.8z"
  })))));
};
export { SvgTralli as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI4NzVfOTM2OSkiPgo8bWFzayBpZD0ibWFzazBfMjg3NV85MzY5IiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSI4IiB3aWR0aD0iMTQwIiBoZWlnaHQ9IjI1Ij4KPHBhdGggZD0iTTM4LjE4ODIgMTguMjU1OUg1Mi41MDM4VjIwLjMyMTlINDYuMzY2NFYzMC42MDYyQzQ2LjM2NjQgMzEuNzQwNSA0NS40NTE2IDMyLjY2MDggNDQuMzIzOSAzMi42NjA4VjIwLjMyMTlIMzguMTg2NVYxOC4yNTU5SDM4LjE4ODJaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTEuMDk3IDE2LjkxNDdMMC43OTk4MDUgMjAuMzEwOUw5LjA5MTE2IDIwLjMxNDJWMzIuNjIzNEwxNS4yNTg1IDIwLjMxMDlIMjUuNjc3MkwzMi4wNzU3IDEzLjk4MUMzMS42NDY2IDEzLjk2OTUgMzEuMjE1OCAxMy45NjI5IDMwLjc4MzQgMTMuOTYyOUMyMy45NTI0IDEzLjk2MjkgMTYuODIyIDE1LjM3ODcgMTEuMDk3IDE2LjkxNDdaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMjg3NV85MzY5KSIvPgo8cGF0aCBkPSJNMzguMTE3IDguMDAxOTVMMzIuOTY3NiAxMy4wOTcyQzI4LjU4OTkgMTIuODk0NyAyNC4wMjA5IDEzLjMzNTkgMTkuNzExNCAxNC4wNzM0TDM4LjExNyA4LjAwMTk1WiIgZmlsbD0id2hpdGUiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzI4NzVfOTM2OSkiPgo8cmVjdCB4PSIwLjc5OTgwNSIgeT0iNC40MDIzNCIgd2lkdGg9IjM3LjIiIGhlaWdodD0iMjcuNiIgZmlsbD0iIzJDMkMyQyIvPgo8L2c+CjwvZz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8yODc1XzkzNjkiIHgxPSIzMi41MzIxIiB5MT0iMTAuNzAzMiIgeDI9IjQuODczNDUiIHkyPSIyNi44MzY3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNGNEFDNzkiIHN0b3Atb3BhY2l0eT0iMCIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGNEFDNzkiLz4KPC9saW5lYXJHcmFkaWVudD4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yODc1XzkzNjkiPgo8cmVjdCB3aWR0aD0iMzguNCIgaGVpZ2h0PSIzOC40IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC43OTk4MDUgMC44MDA3ODEpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";